import { createContext, useContext } from "react"

// True while a page is mounted out of sight, waiting for its town check (RequireLiveCommunity).
// Such a page may load, but it must not act as if it were open: no tab title, no change of address,
// so a town that isn't live sends the visitor on before either happens (CVL-167).
export const HiddenPageContext = createContext(false)

export const usePageHidden = (): boolean => useContext(HiddenPageContext)
